var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-empty",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#freepik_stories-empty:not(.animated) .animable{opacity:0}")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-70",
    style: {
      transformOrigin: "241.538px 250.584px 0",
      animation: ".5s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "219.085px 418.915px 0"
    },
    id: "eljzfiluh75on",
    className: "animable",
    d: "M167.01 378.75h104.15v80.33H167.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.07 458.52c-.14 0-.26-17.91-.26-40s.12-40 .26-40 .26 17.91.26 40-.12 40-.26 40z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "245.07px 418.52px 0"
    },
    id: "elj2wns49h44",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "258.34px 445.315px 0"
    },
    id: "elxtkmlckq41d",
    className: "animable",
    d: "M254.35 440.8h7.98v9.03h-7.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "204.705px 387.53px 0"
    },
    id: "elzbf1zljnmph",
    className: "animable",
    d: "M198.79 378.96h11.83v17.14h-11.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "204.705px 450.27px 0"
    },
    id: "elvxm7dzfwjbj",
    className: "animable",
    d: "M198.79 441.7h11.83v17.14h-11.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "394.485px 409.255px 0"
    },
    id: "eligli7zvfndh",
    className: "animable",
    d: "M328.82 358.61h131.33V459.9H328.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.24 459.18c-.14 0-.26-22.57-.26-50.42s.12-50.42.26-50.42.26 22.57.26 50.42-.11 50.42-.26 50.42z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "427.24px 408.76px 0"
    },
    id: "elswjq8t802ia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "443.975px 442.53px 0"
    },
    id: "el3jmyxxobzom",
    className: "animable",
    d: "M438.94 436.84h10.07v11.38h-10.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "376.34px 369.675px 0"
    },
    id: "el0vrbnhxxfsvc",
    className: "animable",
    d: "M368.88 358.87h14.92v21.61h-14.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "376.34px 448.785px 0"
    },
    id: "el1ycbc56ppuy",
    className: "animable",
    d: "M368.88 437.98h14.92v21.61h-14.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.46 361.59c5.32-2.74 11.58-3.1 17.48-2.12 3.17.52 6.47 1.47 8.63 3.85s2.56 6.57.09 8.62c-1.48 1.22-3.53 1.4-5.45 1.38-4.62-.06-9.74-.87-13.43 1.91-2.11 1.59-3.51 4.22-6 5s-5.24-.69-6.54-2.91a10.15 10.15 0 0 1-.74-7.51 11.45 11.45 0 0 1 5.96-8.22z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "92.2266px 369.708px 0"
    },
    id: "elv35lgueyxlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28 338.08c3.25 4.64 9.57 3.11 12.5.27s4.17-6.94 5.29-10.85c2.58-8.95 5.17-18.34 3.26-27.45a15.19 15.19 0 0 0-3.51-7.46 8 8 0 0 0-7.54-2.51c-3.19.84-5.17 4-6.6 6.93a65.29 65.29 0 0 0-6.46 28.07c0 4.53.51 9.27 3.06 13",
    style: {
      fill: "#ebebeb",
      transformOrigin: "78.605px 315.481px 0"
    },
    id: "elh4vxwes15wh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.36 344.74c3.53-4.19 4.2-10.29 2.63-15.54s-5.12-9.71-9.21-13.36a49.6 49.6 0 0 0-16.48-9.72 17.58 17.58 0 0 0-7.42-1.26 7.77 7.77 0 0 0-6.22 3.76c-1.74 3.31-.07 7.32 1.73 10.6a125.87 125.87 0 0 0 10.82 16.49c3.25 4.18 7 8.31 11.91 10.2s10.09 1.67 12.71-1.76",
    style: {
      fill: "#ebebeb",
      transformOrigin: "43.3582px 325.968px 0"
    },
    id: "eltdv86cq6v2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06 408.1a10.07 10.07 0 0 0 .3-2.1c.15-1.54.33-3.47.56-5.76a84 84 0 0 1 1.29-8.44 64.62 64.62 0 0 1 3.07-10 37 37 0 0 1 5.09-9 19.22 19.22 0 0 1 6.43-5.35 18.1 18.1 0 0 1 5.42-1.68 9.88 9.88 0 0 0 2.1-.31 9.72 9.72 0 0 0-2.13 0 16.37 16.37 0 0 0-5.65 1.47 18.94 18.94 0 0 0-6.79 5.4 35.67 35.67 0 0 0-5.28 9.19 61.15 61.15 0 0 0-3 10.13 73.35 73.35 0 0 0-1.13 8.55c-.18 2.45-.25 4.43-.28 5.8a10 10 0 0 0 0 2.1z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "81.1624px 386.751px 0"
    },
    id: "elfxdgf50a4ml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.46 403.68a4.25 4.25 0 0 0 .06-1v-2.8c0-2.43 0-5.95.12-10.29.22-8.68 1-18 2.41-31.19 1.37-12.39 3.2-26.8 5.14-36.17.41-2.13.83-4.05 1.23-5.73s.69-3.14 1-4.31.48-2 .66-2.72a4.1 4.1 0 0 0 .17-1 4 4 0 0 0-.34.92c-.22.71-.49 1.59-.82 2.68s-.73 2.61-1.15 4.28-.9 3.59-1.35 5.72a317 317 0 0 0-5.41 33.56c-1.44 13.2-2.09 25.22-2.15 33.92 0 4.35 0 7.88.15 10.31.07 1.13.13 2.06.17 2.79a4.31 4.31 0 0 0 .11 1.03z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "74.64px 356.075px 0"
    },
    id: "elxtsgi37y6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 380.5a18.8 18.8 0 0 0 0-2.93c-.11-1.88-.37-4.59-.9-7.92A104.22 104.22 0 0 0 66 358.11a95.33 95.33 0 0 0-4.83-13.66A72.62 72.62 0 0 0 47 322.39a35.08 35.08 0 0 0-3.34-3.1c-.51-.44-1-.87-1.42-1.21l-1.24-.89a17.72 17.72 0 0 0-2.47-1.58c-.14.19 3.49 2.33 8.07 7.2a76.6 76.6 0 0 1 13.82 22 106.14 106.14 0 0 1 4.85 13.53A117.56 117.56 0 0 1 68 369.76c.6 3.29 1 6 1.16 7.84a18.36 18.36 0 0 0 .36 2.9z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "54.0516px 348.055px 0"
    },
    id: "elyqr0gnrkogi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "68.325px 433.775px 0"
    },
    id: "elwkagk6ha6bq",
    className: "animable",
    d: "m45.56 417.86 2.32 31.83h40.89l2.32-31.83H45.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "68.785px 411.59px 0"
    },
    id: "elz6vdzq44rln",
    className: "animable",
    d: "M41.61 405.32h54.35v12.54H41.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "68.34px 450.205px 0"
    },
    id: "el3vx6wr9l6dk",
    className: "animable",
    d: "M41.61 448.47v3.47h53.46v-3.47H41.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "68.645px 454.62px 0"
    },
    id: "elsia27kmt8ye",
    className: "animable",
    d: "m46.67 457.68-2.5-6.12h48.95l-2.92 6.12H46.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.33 428.26a1.48 1.48 0 0 1-.19.3c-.16.21-.37.48-.61.81l-2.38 3-.11.14-.1-.14-5.85-8.09h.33l-5.76 8.15-.18.26-.2-.24-6.83-8.13h.39l-.37.48-6.11 7.65-.21.26-.18-.27-5.77-8.15h.34l-7.1 8.08-.12.15-.1-.17-2.22-3.68c-.24-.4-.42-.73-.57-1a1.55 1.55 0 0 1-.18-.36 1.54 1.54 0 0 1 .24.32l.63.95 2.33 3.67h-.22l7-8.18.17-.21.16.22 5.82 8.12H62l6.09-7.67c.13-.16.26-.32.37-.47l.2-.25.2.24 6.81 8.15h-.38l5.82-8.11.17-.24.16.24c2.31 3.29 4.27 6.08 5.73 8.18h-.21l2.48-3c.27-.31.49-.56.66-.77a2.27 2.27 0 0 1 .23-.24z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "68.29px 428.26px 0"
    },
    id: "elj0pl6rbxc3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.66 417.65c0 .14-10.25.26-22.88.26s-22.88-.12-22.88-.26 10.24-.25 22.88-.25 22.88.11 22.88.25z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "68.78px 417.655px 0"
    },
    id: "el2nyegtjnba1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4gm9lu7tw62"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "374.34px 77.69px 0",
      transform: "rotate(-.31deg)"
    },
    className: "animable",
    id: "el51kypfgpb76",
    d: "M370.15 56.84h8.38v41.7h-8.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0exebreee2hr"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "308.35px 68.5px 0",
      transform: "rotate(-.31deg)"
    },
    className: "animable",
    id: "eligfpijzox6",
    d: "M297.5 56.99h21.7v23.02h-21.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elr8kec4ju3eh"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "329.95px 68.38px 0",
      transform: "rotate(-.31deg)"
    },
    className: "animable",
    id: "elx2ybe96xseh",
    d: "M319.1 56.87h21.7v23.02h-21.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.47 63.4q21.64.18 43.3-.2a.23.23 0 0 0 0-.46c-14.42-.08-28.88 0-43.3.27a.2.2 0 0 0 0 .39z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "319.157px 63.0842px 0"
    },
    id: "el9zapjuwj3go",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkeigb5sn5zl"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "303.675px 89.05px 0",
      transform: "rotate(-.31deg)"
    },
    className: "animable",
    id: "elwz4tqg1hm1",
    d: "M283.96 79.67h39.43v18.76h-39.43z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eli6wqo51fjl"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "342.915px 88.84px 0",
      transform: "rotate(-.31deg)"
    },
    className: "animable",
    id: "elq867yfum28q",
    d: "M323.2 79.46h39.43v18.76H323.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283.94 85c26.19.29 52.47 0 78.67-.39a.23.23 0 0 0 0-.46c-26.19-.14-52.48-.13-78.67.45a.2.2 0 0 0 0 .4z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "323.29px 84.5966px 0"
    },
    id: "elont40mnf6om",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "345.57px 101.9px 0"
    },
    id: "elud4656vsuwi",
    className: "animable",
    d: "M269.19 98.54h152.76v6.72H269.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "297.3px 113.235px 0"
    },
    id: "elk89cgyprlfj",
    className: "animable",
    d: "M294.2 101.77h6.2v22.93h-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "389.87px 113.235px 0"
    },
    id: "elav967xwm92q",
    className: "animable",
    d: "M386.77 101.77h6.2v22.93h-6.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elly7zdfkm2la"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "382.56px 69.965px 0",
      transform: "rotate(-.31deg)"
    },
    className: "animable",
    id: "elgzw2ln9cylc",
    d: "M378.37 41.29h8.38v57.35h-8.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elv5h4awx0iw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "393.3px 75.22px 0",
      transform: "rotate(-.31deg)"
    },
    className: "animable",
    id: "elna9knfcvkvk",
    d: "M386.79 51.98h13.02v46.48h-13.02z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.6 60.9a92.25 92.25 0 0 1-13 0 96.43 96.43 0 0 1 13 0z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "393.1px 60.905px 0"
    },
    id: "elnyypzfbq0oc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6 59a48.59 48.59 0 0 1-6.51.22 48.72 48.72 0 0 1-6.51-.22 92.25 92.25 0 0 1 13 0z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "393.09px 59.0088px 0"
    },
    id: "elv0v3bkktus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6 91.43a92.25 92.25 0 0 1-13 0 96.43 96.43 0 0 1 13 0z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "393.1px 91.435px 0"
    },
    id: "elrdb4x5qmuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6 89.48a96.43 96.43 0 0 1-13 0 92.25 92.25 0 0 1 13 0z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "393.1px 89.475px 0"
    },
    id: "eljwh0gc14bc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.3 85.22c-.12 0-.22-4.69-.22-10.47s.1-10.48.22-10.48.23 4.69.23 10.48-.1 10.47-.23 10.47z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "393.305px 74.745px 0"
    },
    id: "el4cl5xe0908u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "406.835px 80.9px 0"
    },
    id: "el8m4vjda7nit",
    className: "animable",
    d: "M399.75 63.36h14.17v35.08h-14.17z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.28,
    cy: 51.06,
    r: 2.41,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "382.28px 51.06px 0"
    },
    id: "elxlylc64yj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "382.285px 74.75px 0"
    },
    id: "elnzbhb2gnfol",
    className: "animable",
    d: "M381.54 57.69h1.49v34.12h-1.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-70",
    style: {
      transformOrigin: "250px 459.35px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.66 459.35c0 .15-96.12.26-214.65.26s-214.67-.11-214.67-.26 96.1-.26 214.67-.26 214.65.12 214.65.26z",
    style: {
      fill: "#263238",
      transformOrigin: "250px 459.35px 0"
    },
    id: "el920ebcfssbi",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-70",
    style: {
      transformOrigin: "159.011px 276.361px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.21 92.35a32 32 0 0 1 7.22 20.46c-.05 4.22-.83 8.87 1.63 12.3 1.86 2.6 5.26 3.91 6.77 6.73 1.82 3.39.27 7.68 1.39 11.36 1.58 5.22 7.7 7.41 11.33 11.48a14.52 14.52 0 0 1 3 13.28 14.92 14.92 0 0 1-9.38 9.92 9.72 9.72 0 0 1-7.42-.12c-2.45-1.22-4-3.73-5.2-6.18-2.41-4.82-23.58-30.87-24.78-36.13",
    style: {
      fill: "#263238",
      transformOrigin: "157.415px 135.454px 0"
    },
    id: "el8hp8k7tkxag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81 86.21c-8.66-1.4-17 4.35-20.63 12.33s-3.75 17-4 25.8-.89 17.92-5.36 25.46c-2.84 4.79-7.24 9-7.93 14.51-.62 4.94 1.94 9.92 1.09 14.83-.74 4.28-4 8-3.87 12.33.16 5.22 5.53 9.15 10.74 9.29s10.09-2.59 14.18-5.83a54.5 54.5 0 0 0 15.57-19.79",
    style: {
      fill: "#263238",
      transformOrigin: "113.458px 143.382px 0"
    },
    id: "el3jyhtn2f0ye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.56 106.85A16.39 16.39 0 0 1 134.3 88.5c8.73-.84 16.5 5.67 17.81 14.35 1.15 7.61 2.13 15.29 2.1 18.08-.11 8.41-5 11.68-7 12.67a11.26 11.26 0 0 1-2.22.55v.06l1.86 9.66c.85 6.33-2.68 12-9 12.89s-11.29-3.94-12.26-10.27z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "136.822px 122.646px 0"
    },
    id: "el1robtxg9jwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.39 106.53c-.14.2-1.25-.39-2.67-.18s-2.37 1.07-2.55.92 0-.4.44-.8a3.68 3.68 0 0 1 2-1 3.5 3.5 0 0 1 2.16.36c.5.32.69.62.62.7z",
    style: {
      fill: "#263238",
      transformOrigin: "147.752px 106.358px 0"
    },
    id: "elv32ilv1naqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.73 109.61c-.14.2-1.25-.4-2.68-.19s-2.36 1.08-2.54.93 0-.41.44-.8a3.68 3.68 0 0 1 2-1 3.58 3.58 0 0 1 2.16.37c.49.31.69.6.62.69z",
    style: {
      fill: "#263238",
      transformOrigin: "135.092px 109.441px 0"
    },
    id: "ela7mew931kat",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.92 117.24a9.39 9.39 0 0 1 2.25-.75c.36-.09.69-.21.72-.47a1.87 1.87 0 0 0-.4-1l-1.49-2.66c-2.07-3.72-3.62-6.8-3.47-6.89s2 2.88 4 6.6c.51.92 1 1.8 1.44 2.63a2.17 2.17 0 0 1 .4 1.4.91.91 0 0 1-.52.62 2.54 2.54 0 0 1-.61.18 9 9 0 0 1-2.32.34z",
    style: {
      fill: "#263238",
      transformOrigin: "143.447px 111.354px 0"
    },
    id: "elpasd2jsotjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.91 134.16s-5.43 1.25-12.91-1.88c0 0 3.23 6.95 13.42 4.48z",
    style: {
      fill: "#eb996e",
      transformOrigin: "138.71px 134.785px 0"
    },
    id: "elmr59qtqll4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 105.88c-.08.41-1.53.43-3.17.88s-2.93 1.09-3.2.78c-.12-.15.06-.55.55-1a5.72 5.72 0 0 1 4.85-1.26c.66.15.97.41.97.6z",
    style: {
      fill: "#263238",
      transformOrigin: "133.797px 106.394px 0"
    },
    id: "el8erj7nbpqk6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.22 103.38c-.2.36-1.23.17-2.41.32s-2.15.54-2.43.23c-.12-.15 0-.49.38-.86a3.32 3.32 0 0 1 1.88-.82 3.41 3.41 0 0 1 2 .37c.48.27.67.58.58.76z",
    style: {
      fill: "#263238",
      transformOrigin: "146.788px 103.136px 0"
    },
    id: "elq6sbfax9xx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.64 111.45a1.18 1.18 0 0 0 1.35 1 1.14 1.14 0 0 0 1-1.28 1.19 1.19 0 0 0-1.35-1 1.13 1.13 0 0 0-1 1.28z",
    style: {
      fill: "#263238",
      transformOrigin: "135.814px 111.311px 0"
    },
    id: "elqkbeo3c4af",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25 108.72a1.19 1.19 0 0 0 1.35 1 1.14 1.14 0 0 0 1-1.28 1.19 1.19 0 0 0-1.35-1 1.13 1.13 0 0 0-1 1.28z",
    style: {
      fill: "#263238",
      transformOrigin: "148.424px 108.58px 0"
    },
    id: "elduu8slgipem",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.16 120a1.76 1.76 0 0 0-2.08.86 1.83 1.83 0 0 0 .25 2.11 1.61 1.61 0 0 0 2.08.15 2 2 0 0 0 .65-1.36 1.92 1.92 0 0 0-.32-1.36 1.09 1.09 0 0 0-1.27-.38",
    style: {
      fill: "#eb996e",
      transformOrigin: "144.467px 121.676px 0"
    },
    id: "elmcv7hjks32g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 96a12.88 12.88 0 0 0-5.48-7.7 14.3 14.3 0 0 0-7.66-2.69 10.51 10.51 0 0 0-7.54 2.74A7.84 7.84 0 0 0 128 93.8l.16-1.4a5.1 5.1 0 0 0 0 3.53c.23.61.51 1.23.75 1.84a7.9 7.9 0 0 0 3.74 4.07 5.14 5.14 0 0 0 2.5.61 3 3 0 0 0 2.27-1.11 5 5 0 0 0 .54-3.58 8.55 8.55 0 0 0 2.73 3 3 3 0 0 0 3.76-.43c.82-1 .5-2.58 0-3.82a7.56 7.56 0 0 0 3.13 2.69 2.79 2.79 0 0 0 2.23.24 2.17 2.17 0 0 0 1.16-1.5A4.58 4.58 0 0 0 151 96z",
    style: {
      fill: "#263238",
      transformOrigin: "139.467px 94.0254px 0"
    },
    id: "eld3qbx5nr7kv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.77 98.66c-.09 0-.07-1.19-.46-3a11.44 11.44 0 0 0-3.45-6.27 8.19 8.19 0 0 0-3.46-1.87 7.52 7.52 0 0 0-3.22-.08 9.29 9.29 0 0 0-2.78 1.15s.17-.25.61-.57a6.14 6.14 0 0 1 2.09-.94 7.48 7.48 0 0 1 3.41 0 8.47 8.47 0 0 1 3.7 2 11.19 11.19 0 0 1 3.47 6.59 14.47 14.47 0 0 1 .18 2.26 2.14 2.14 0 0 1-.09.73z",
    style: {
      fill: "#455a64",
      transformOrigin: "137.131px 92.7715px 0"
    },
    id: "elor94upcalsh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.87 215.25 197.42 200s-19.69-25.83-19.28-26.33l-13.83 15.14 20.1 27.19L231 226.92l8-2.22c-1.76-8.49-3.13-9.45-3.13-9.45z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "201.655px 200.295px 0"
    },
    id: "elavflunfk9z4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.07 141.56-5.24-2-22.62 2.87v4l-.65.08a46.34 46.34 0 0 0-13.85 5.38 23.64 23.64 0 0 0-11 24.07c.92 5.72 2.7 12.67 6.14 16.69 6.57 7.69 12.57-1.81 12.57-1.81s4.12 9.4 3.88 13.85c-.2 3.73-1.84 11.49-2.37 13.91a.73.73 0 0 0 .59.88l47.72 8.83.23-11.67-1.52-48L163.8 150s.07-8.9-11.73-8.44z",
    style: {
      fill: "#395dab",
      transformOrigin: "132.928px 183.935px 0"
    },
    id: "el34bpevixz1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#395dab",
      transformOrigin: "172.17px 168.965px 0"
    },
    id: "el6rp80riicr4",
    className: "animable",
    d: "m163.07 146.9 18.2 26.29-14.65 17.84-3.55-44.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 202.22a11.48 11.48 0 0 1-.07-1.7c0-1.18 0-2.73-.06-4.62a140.17 140.17 0 0 0-1.09-15.17c-.75-5.9-1.9-11.17-2.77-15l-1.06-4.5a11.59 11.59 0 0 1-.34-1.66 9.55 9.55 0 0 1 .54 1.61c.31 1 .73 2.57 1.21 4.47a122.55 122.55 0 0 1 2.94 15 117.7 117.7 0 0 1 .94 15.24c0 2-.05 3.54-.11 4.63a10 10 0 0 1-.13 1.7z",
    style: {
      fill: "#263238",
      transformOrigin: "164.425px 180.895px 0"
    },
    id: "elhu85gyzf9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2 162.25c0 .08-1.38.07-3.59.18a58.14 58.14 0 0 0-8.58 1.11 59.45 59.45 0 0 0-8.32 2.39c-2.08.77-3.33 1.34-3.37 1.26a3.57 3.57 0 0 1 .84-.49c.55-.3 1.37-.68 2.4-1.11a46.58 46.58 0 0 1 17-3.52c1.12 0 2 0 2.65.06a3.16 3.16 0 0 1 .97.12z",
    style: {
      fill: "#fafafa",
      transformOrigin: "110.27px 164.634px 0"
    },
    id: "ela5kvyx2kmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.35 174.28a8.85 8.85 0 0 1-2.27.5 50.47 50.47 0 0 1-11.17.38 9 9 0 0 1-2.3-.34 13.11 13.11 0 0 1 2.32 0h5.56c2.17 0 4.13-.22 5.55-.35a12.77 12.77 0 0 1 2.31-.19z",
    style: {
      fill: "#fafafa",
      transformOrigin: "156.48px 174.794px 0"
    },
    id: "el3jilu9700aa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7 162.39a14.16 14.16 0 0 1-3.9 3.15 13.72 13.72 0 0 1-4.59 2c-.06-.14 2-1 4.32-2.48s4.07-2.79 4.17-2.67z",
    style: {
      fill: "#fafafa",
      transformOrigin: "168.454px 164.961px 0"
    },
    id: "elwmw6s6sskag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35 150.2a18.86 18.86 0 0 1-11.41 4.8c0-.16 2.75-.58 5.91-1.93s5.4-3 5.5-2.87z",
    style: {
      fill: "#fafafa",
      transformOrigin: "159.645px 152.596px 0"
    },
    id: "eliiddkjmn5ic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.34 194.64a4.77 4.77 0 0 1-.94.49c-.63.3-1.54.67-2.7 1.1a49.89 49.89 0 0 1-9.29 2.36 49.06 49.06 0 0 1-9.57.53 33.19 33.19 0 0 1-2.9-.23 4.74 4.74 0 0 1-1.05-.19c0-.09 1.52 0 4 .06a58.78 58.78 0 0 0 18.73-2.88c2.28-.75 3.69-1.32 3.72-1.24z",
    style: {
      fill: "#fafafa",
      transformOrigin: "153.115px 196.898px 0"
    },
    id: "elkveduv2mzx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.71 208.19s-.14.1-.43.25L165 209c-1.1.52-2.73 1.2-4.77 2s-4.51 1.57-7.29 2.33a85.94 85.94 0 0 1-18.5 2.87c-2.88.11-5.47.1-7.65 0s-3.93-.26-5.14-.43l-1.39-.19a1.85 1.85 0 0 1-.48-.1 1.56 1.56 0 0 1 .49 0l1.4.09c1.21.1 3 .2 5.13.26s4.76 0 7.62-.1 6-.46 9.27-1 6.35-1.19 9.13-1.89 5.24-1.49 7.28-2.22 3.7-1.34 4.82-1.8l1.3-.51a2.41 2.41 0 0 1 .49-.12z",
    style: {
      fill: "#fafafa",
      transformOrigin: "143.245px 212.234px 0"
    },
    id: "elne7e9ht27e8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79 420.78-5.41 24.43-9.87 18.09a2.57 2.57 0 0 0 1.18 3.56 2.55 2.55 0 0 0 2.34-.11c4.58-2.64 21.39-12.47 21.68-14.28.35-2.09 7.42-25.39 7.42-25.39z",
    style: {
      fill: "#395dab",
      transformOrigin: "79.8741px 443.936px 0"
    },
    id: "elims3rntek7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyamo6fw9xns"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "77.115px 458.99px 0"
    },
    className: "animable",
    id: "el0njqp0ejzbt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.9 466.86 24.43-16-.26 1a3.86 3.86 0 0 1-1.48 2.22c-2 1.43-7.57 5.27-20.27 12.69a2.56 2.56 0 0 1-2.42.09z",
    style: {
      fill: "#fff",
      transformOrigin: "77.115px 458.99px 0"
    },
    id: "el7r2wp5d8c2x",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elcf518muk60t"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "86.7648px 443.146px 0"
    },
    className: "animable",
    id: "elqt9nxyaa6r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.26 441.77a1.55 1.55 0 0 0-.89 1.87 1.49 1.49 0 0 0 1.84.9 1.64 1.64 0 0 0 .94-2 1.55 1.55 0 0 0-2-.73",
    style: {
      fill: "#fff",
      transformOrigin: "86.7648px 443.146px 0"
    },
    id: "elbzxoptfpe6b",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M73.06 457.6a8 8 0 0 0-1.67-2.41 7.77 7.77 0 0 0-2.67-1.19c0-.07.35-.18.94-.12a4 4 0 0 1 2.08.92 3.88 3.88 0 0 1 1.26 1.86c.17.57.12.94.06.94z",
    style: {
      fill: "#263238",
      transformOrigin: "70.9182px 455.731px 0"
    },
    id: "elncn05ju2dvk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.53 460.43c-.14.08-.73-.9-1.9-1.57a18.79 18.79 0 0 0-2.3-.89 2.86 2.86 0 0 1 2.58.41c1.33.77 1.76 2.02 1.62 2.05z",
    style: {
      fill: "#263238",
      transformOrigin: "68.4426px 459.131px 0"
    },
    id: "eluj1jcwai6so",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3 454.22a24.4 24.4 0 0 0-2.76-2.62 24.8 24.8 0 0 0-3.4-1.73 5.71 5.71 0 0 1 3.72 1.28 5.6 5.6 0 0 1 2.44 3.07z",
    style: {
      fill: "#263238",
      transformOrigin: "74.22px 452.044px 0"
    },
    id: "elexzw41plcaw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.57 446.93c-.1.13-1.31-.76-3-1.25s-3.22-.41-3.23-.58a6.38 6.38 0 0 1 6.27 1.83z",
    style: {
      fill: "#263238",
      transformOrigin: "76.475px 445.919px 0"
    },
    id: "elajn2qbt5a48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.34 439.8a12.65 12.65 0 0 0-3.13-1.39 12.68 12.68 0 0 0-3.42 0c0-.06.31-.3.95-.49a5.59 5.59 0 0 1 4.92 1c.51.48.72.84.68.88z",
    style: {
      fill: "#263238",
      transformOrigin: "78.0674px 438.762px 0"
    },
    id: "elc968es80wmh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.58 437.06a2.24 2.24 0 0 1 .2-.92 6.4 6.4 0 0 1 1.32-2.23 2.94 2.94 0 0 1 1.54-1.06 1.06 1.06 0 0 1 1.08.5 1.68 1.68 0 0 1 .11 1.2 3.63 3.63 0 0 1-3.88 2.5 4.22 4.22 0 0 1-3.49-3.12 1.5 1.5 0 0 1 .23-1.2 1 1 0 0 1 1.15-.27 3.65 3.65 0 0 1 1.4 1.23 7.39 7.39 0 0 1 1.19 2.31 2.3 2.3 0 0 1 .17.94 11.48 11.48 0 0 0-1.67-3 3.38 3.38 0 0 0-1.24-1 .54.54 0 0 0-.63.15 1 1 0 0 0-.1.79A3.77 3.77 0 0 0 79 436.5a3.15 3.15 0 0 0 3.33-2.07 1.25 1.25 0 0 0 0-.84.56.56 0 0 0-.59-.28 2.63 2.63 0 0 0-1.33.86 10.28 10.28 0 0 0-1.83 2.89z",
    style: {
      fill: "#263238",
      transformOrigin: "79.1569px 434.728px 0"
    },
    id: "el1mrvgrel3nu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvp7775tg9no"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "86.755px 426.375px 0"
    },
    className: "animable",
    id: "elcsbpmextqzp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "el2d8d9o1yo4g",
    style: {
      transformOrigin: "86.755px 426.375px 0"
    },
    className: "animable",
    d: "m78.34 423.43-1.17 5.6 17.69 2.94 1.48-4.89-17.37-6.3-.63 2.65z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m158 429.82-1.46 19.52s19.36 8 19.44 11.68l-38-1.47 1-30.52z",
    style: {
      fill: "#395dab",
      transformOrigin: "156.98px 445.025px 0"
    },
    id: "elk5phnnj4mvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz08uq1gwjo9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "145.202px 448.679px 0"
    },
    className: "animable",
    id: "elovnft6efi1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.89 447.24a1.56 1.56 0 0 0-1.14 1.73 1.5 1.5 0 0 0 1.7 1.15 1.64 1.64 0 0 0 1.2-1.84 1.55 1.55 0 0 0-1.9-1",
    style: {
      fill: "#fff",
      transformOrigin: "145.202px 448.679px 0"
    },
    id: "el0bpemr7gchxe",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el3ijxqbqk67x"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "157.012px 458.735px 0"
    },
    className: "animable",
    id: "ell0eu6g8brhe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m138 459.55.22-3.08 36.35 2.53s1.67.8 1.43 2z",
    style: {
      fill: "#fff",
      transformOrigin: "157.012px 458.735px 0"
    },
    id: "elqorinr6jmva",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M157.18 449.17c0 .19-.94.24-1.87.8s-1.45 1.32-1.62 1.24.15-1.14 1.29-1.8 2.25-.41 2.2-.24z",
    style: {
      fill: "#263238",
      transformOrigin: "155.414px 450.097px 0"
    },
    id: "eld203g5ej74",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.1 451c0 .19-.78.47-1.44 1.23s-.87 1.58-1.06 1.57-.26-1.07.58-2 1.92-1 1.92-.8z",
    style: {
      fill: "#263238",
      transformOrigin: "159.789px 452.354px 0"
    },
    id: "elx5h6upxvsib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.18 455.83c-.17 0-.39-.91.12-1.9s1.4-1.37 1.47-1.21-.48.68-.89 1.5-.52 1.6-.7 1.61z",
    style: {
      fill: "#263238",
      transformOrigin: "163.88px 454.257px 0"
    },
    id: "elhj2e8m3n459",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 444.69c-.08.16-.92-.13-2-.1s-1.88.33-2 .17.72-.79 2-.81 2.12.6 2 .74z",
    style: {
      fill: "#263238",
      transformOrigin: "155px 444.378px 0"
    },
    id: "el0sub6ty3e4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkktl6jy9twh"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "148.275px 434.71px 0"
    },
    className: "animable",
    id: "elybom77vckw"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eln9jijih3db8",
    style: {
      transformOrigin: "148.275px 434.71px 0"
    },
    className: "animable",
    d: "m157.73 433.69-.26 3.48-18.65-.9.13-4.02 18.78 1.44z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 440.74a3.45 3.45 0 0 1-1.9-.08 8.33 8.33 0 0 1-2-.69 9.18 9.18 0 0 1-1.07-.62 2.49 2.49 0 0 1-.56-.47.82.82 0 0 1 0-1 1 1 0 0 1 .83-.39 2.84 2.84 0 0 1 .71.12 6.68 6.68 0 0 1 1.16.46 6.52 6.52 0 0 1 1.71 1.21c.85.85 1.12 1.56 1.06 1.59s-.49-.54-1.36-1.25a8 8 0 0 0-1.66-1 10.51 10.51 0 0 0-1.08-.38c-.4-.12-.74-.13-.85 0s0 .1 0 .22a1.89 1.89 0 0 0 .41.34 9.73 9.73 0 0 0 1 .61 10.17 10.17 0 0 0 1.81.78 13.15 13.15 0 0 1 1.79.55z",
    style: {
      fill: "#263238",
      transformOrigin: "154.4px 439.18px 0"
    },
    id: "elknkiidwkpns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 441a3.15 3.15 0 0 1-.43-1.86 6.7 6.7 0 0 1 .34-2.07 7.18 7.18 0 0 1 .53-1.13 1.59 1.59 0 0 1 1.25-.92.9.9 0 0 1 .78.57 2.49 2.49 0 0 1 .16.7 4.18 4.18 0 0 1 0 1.28 4.38 4.38 0 0 1-.89 1.93c-.78 1-1.56 1.15-1.58 1.09s.6-.43 1.21-1.36a4.32 4.32 0 0 0 .67-1.76 4 4 0 0 0 0-1.1c-.05-.4-.19-.74-.34-.7s-.52.28-.69.6a7.36 7.36 0 0 0-.51 1 7.11 7.11 0 0 0-.44 1.88c-.13 1.12.04 1.85-.06 1.85z",
    style: {
      fill: "#263238",
      transformOrigin: "158.12px 438.01px 0"
    },
    id: "el7g0jbb8pivw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.72 219.3s-6 .27-10 20.79-34.49 186.79-34.49 186.79l22.11.2L138 269l-2.77 163 22.46 1.72s16.85-180.29 17-190.78c.2-13.08-7.31-26.31-7.31-26.31z",
    style: {
      fill: "#263238",
      transformOrigin: "124.462px 325.175px 0"
    },
    id: "elkqpt355j66b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.11 217.55c.14 0-2.16 11.75-5.13 26.18s-5.49 26.11-5.63 26.08 2.15-11.75 5.12-26.18 5.53-26.11 5.64-26.08z",
    style: {
      fill: "#455a64",
      transformOrigin: "143.73px 243.68px 0"
    },
    id: "el3to97tk1ey9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.55 220.48c0-.06.6-.24 1.29.37a1.83 1.83 0 0 1 .6 1.41 1.77 1.77 0 0 1-1.13 1.52 1.79 1.79 0 0 1-1.88-.25 1.87 1.87 0 0 1-.59-1.42c0-.92.62-1.24.63-1.18a2.85 2.85 0 0 0-.26 1.17 1.53 1.53 0 0 0 .53 1.06 1.43 1.43 0 0 0 2.22-.93 1.52 1.52 0 0 0-.38-1.12c-.49-.57-1.04-.55-1.03-.63z",
    style: {
      fill: "#455a64",
      transformOrigin: "152.64px 222.174px 0"
    },
    id: "elh6ilsdhpzkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6 228.6c0-.06.62 0 1 .83a1.76 1.76 0 0 1-.07 1.48 1.76 1.76 0 0 1-3.1-.25 1.74 1.74 0 0 1 .17-1.46c.47-.75 1.11-.73 1.09-.67s-.48.2-.77.84a1.48 1.48 0 0 0 0 1.12 1.33 1.33 0 0 0 2.24.18 1.49 1.49 0 0 0 .13-1.12c-.29-.68-.74-.88-.69-.95z",
    style: {
      fill: "#455a64",
      transformOrigin: "151.036px 230.114px 0"
    },
    id: "eli0qm2mu0bu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.41 220.68a3.83 3.83 0 0 1-.26 1 16.67 16.67 0 0 1-1.17 2.65 19.43 19.43 0 0 1-15.38 10.13 16.64 16.64 0 0 1-2.89 0 4 4 0 0 1-1-.16c0-.1 1.51.07 3.9-.23a20.29 20.29 0 0 0 15.1-9.95c1.17-2.02 1.61-3.47 1.7-3.44z",
    style: {
      fill: "#455a64",
      transformOrigin: "120.06px 227.601px 0"
    },
    id: "ellgo1k96xtie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.43 235.27s-.26-.12-.67-.4a12 12 0 0 1-1.6-1.38 17 17 0 0 1-4.89-12.69 11 11 0 0 1 .27-2.09c.11-.49.18-.75.22-.74s-.12 1.09-.12 2.84a18.54 18.54 0 0 0 4.79 12.43c1.17 1.29 2.05 1.95 2 2.03z",
    style: {
      fill: "#455a64",
      transformOrigin: "169.843px 226.62px 0"
    },
    id: "ely0l4dgnvwzm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 235.85c.33-.8.24-.48-5.06-4 0 0 7.6 5 6.81 2.62a9.7 9.7 0 0 0-2.47-2.29c2 1.18 3.16 1.31 3.51.83.6-.83-3.75-4-5.82-5.43a49.83 49.83 0 0 0 5.94 3.65c1.23.38.64-1.06-.19-2.11s-7.27-7.25-9-9.1a1.5 1.5 0 0 1 0-2.28c3.1-2 4.46-5.19 4.42-6.24a1.13 1.13 0 0 0-2.12-.36 13.72 13.72 0 0 1-2.71 2.56 8.86 8.86 0 0 1-2.62 1.41c-1.1.36-6.51.06-7.67-.53l-3.69 12.51s13.39 6.26 15.93 7.48c3.12 1.48 4.51 1.89 4.74 1.28z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "242.472px 223.328px 0"
    },
    id: "elobx1lpd9cu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.53 230c-.11.15 1.63 1.42 3.88 2.85s4.14 2.46 4.23 2.31-1.65-1.43-3.89-2.85-4.12-2.5-4.22-2.31z",
    style: {
      fill: "#eb996e",
      transformOrigin: "247.584px 232.576px 0"
    },
    id: "elad4vxrj796",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.79 227.55c-.1.15 1.68 1.61 4 3.27s4.24 2.89 4.34 2.75-1.67-1.61-4-3.27-4.23-2.89-4.34-2.75z",
    style: {
      fill: "#eb996e",
      transformOrigin: "248.96px 230.56px 0"
    },
    id: "eldffnfzelq3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.12 225.07c-.1.14 1.56 1.56 3.71 3.16s4 2.78 4.08 2.64-1.55-1.56-3.7-3.16-3.98-2.78-4.09-2.64z",
    style: {
      fill: "#eb996e",
      transformOrigin: "250.014px 227.97px 0"
    },
    id: "eli9kcxra0oq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.93 179.76 9.82.54a49.32 49.32 0 0 0 2.78 8c7.91-13.72 14-32.11 15.56-39.5q-.33-1.09-.81-2.46a10.44 10.44 0 0 1 .12-4.16c.27-1.64.73-3.86.86-4.88.43-3.12.93-3.62 2-3.26 1.48.48-.61 8.77.6 8.95.66.09 1.45-2.75 1.69-5.08s1.28-9.49 2.05-10c1.13-.7 2.11.41 1.83 2.73s-.65 9.35.58 9.44 2.23-11.79 2.23-11.79-.19-2.58 1.23-2.52c2.57.11.57 12.64.35 13.83-.16.82 1.18 1 1.3.08s.74-11.89 3.35-11.8c2 .07-1.55 10.32-.42 12.7s1.91-8.07 3.83-7.93c.71.06 1.24.2-.07 6.11a134.8 134.8 0 0 1-4.59 13.86c-3 16.4-16.39 68.86-37.31 59.26-11.7-5.37-17.17-32-17.17-32z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "129.676px 169.406px 0"
    },
    id: "el5zc6wddlmqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.24 152.71a1.41 1.41 0 0 1 .1-.36c.09-.26.2-.6.35-1 .33-.95.78-2.27 1.37-4s1.3-3.83 2-6.31c.36-1.23.66-2.57.93-4 .14-.72.27-1.46.36-2.22a8.55 8.55 0 0 0 0-1.13c0-.39-.09-.71-.4-.72s-.53.18-.75.51a6.21 6.21 0 0 0-.49 1.11c-.28.79-.5 1.63-.72 2.48s-.42 1.74-.68 2.64a4.11 4.11 0 0 1-.6 1.38.55.55 0 0 1-.27.17.45.45 0 0 1-.38-.09 1.29 1.29 0 0 1-.28-.37 2.86 2.86 0 0 1-.21-.77 24.72 24.72 0 0 1 .6-6c.17-1 .35-2 .48-3 .06-.51.12-1 .13-1.54s-.07-1.11-.28-1.2-.72.19-1 .61a6.12 6.12 0 0 0-.65 1.42 20.75 20.75 0 0 0-.77 3.2c-.19 1.1-.34 2.22-.47 3.36-.05.57-.11 1.14-.16 1.72l-.08.87a1.27 1.27 0 0 1-.4 1 1 1 0 0 1-1.18 0 .82.82 0 0 1-.36-.57 1.13 1.13 0 0 1 0-.32v-.21l.27-1.75c.17-1.18.31-2.36.42-3.56s.2-2.41.22-3.62a12 12 0 0 0-.36-3.56 1.19 1.19 0 0 0-.5-.72.6.6 0 0 0-.67.22 3.27 3.27 0 0 0-.38 1.94c-.22 2.35-.47 4.66-.81 6.93-.17 1.13-.36 2.26-.64 3.37-.08.27-.16.55-.26.83a1.68 1.68 0 0 1-.57.86.6.6 0 0 1-.73-.16 1.2 1.2 0 0 1-.27-.45 4.07 4.07 0 0 1-.23-.86 33.43 33.43 0 0 1-.06-6.55 17.28 17.28 0 0 0 .17-3.07 1.7 1.7 0 0 0-.56-1.14.67.67 0 0 0-.52-.08 1.59 1.59 0 0 0-.27.12c-.09.08-.08 0-.14.17a13.65 13.65 0 0 0-.79 2.79c-.2 1-.37 1.91-.52 2.85s-.29 1.86-.41 2.78-.18 1.82-.36 2.72a14.87 14.87 0 0 1-.7 2.58 5 5 0 0 1-.29.62c-.14.19-.22.43-.6.55a.5.5 0 0 1-.51-.22 1.48 1.48 0 0 1-.16-.37 4 4 0 0 1-.08-.66c0-1.71.23-3.27.32-4.78a12.06 12.06 0 0 0 0-2.17c0-.32-.15-.7-.33-.77a.92.92 0 0 0-.81 0 2.81 2.81 0 0 0-.74 1.64c-.15.61-.21 1.23-.32 1.82-.42 2.36-.86 4.4-1.07 6.06a8.22 8.22 0 0 0 0 2.2c.14.6.35 1.14.46 1.56s.22.72.29 1a1.76 1.76 0 0 1 .08.33 1.31 1.31 0 0 1-.14-.31l-.34-1c-.14-.43-.35-.91-.52-1.57a8 8 0 0 1 0-2.26c.19-1.69.59-3.71 1-6.08.11-.59.17-1.21.3-1.85a9.43 9.43 0 0 1 .27-1 1.7 1.7 0 0 1 .62-.91 1.26 1.26 0 0 1 1.18 0A1.35 1.35 0 0 1 141 135a12.18 12.18 0 0 1 0 2.26c-.07 1.52-.31 3.11-.27 4.73a3.42 3.42 0 0 0 .07.57c0 .19.14.27.12.23s.19-.16.27-.32a4.64 4.64 0 0 0 .26-.55 13.48 13.48 0 0 0 .65-2.5c.17-.87.23-1.77.35-2.7s.24-1.85.39-2.8.32-1.9.51-2.87a13 13 0 0 1 .84-2.95 1 1 0 0 1 .35-.39 1.94 1.94 0 0 1 .42-.17 1.22 1.22 0 0 1 1 .15 2.16 2.16 0 0 1 .81 1.52 6 6 0 0 1 0 1.64c-.05.51-.1 1-.13 1.56a31.86 31.86 0 0 0 .06 6.4 4 4 0 0 0 .2.74.68.68 0 0 0 .15.26h.05v.09-.08a2 2 0 0 0 .29-.55q.14-.37.24-.78c.27-1.06.45-2.18.62-3.3.34-2.25.59-4.56.8-6.9v.05a3.86 3.86 0 0 1 .51-2.37 1.25 1.25 0 0 1 1.39-.41 1.79 1.79 0 0 1 .86 1.1 12.54 12.54 0 0 1 .39 3.77c0 1.24-.11 2.46-.22 3.67s-.26 2.4-.43 3.58c-.09.6-.18 1.18-.27 1.77-.08.37-.06.38 0 .49a.42.42 0 0 0 .47 0c.12-.09.14-.26.17-.59l.07-.87.18-1.73c.12-1.14.28-2.28.47-3.39a22.87 22.87 0 0 1 .8-3.29 7.29 7.29 0 0 1 .73-1.55 2.23 2.23 0 0 1 .64-.66 1.1 1.1 0 0 1 1-.15 1.17 1.17 0 0 1 .55.88 4.91 4.91 0 0 1 .05.85c0 .55-.07 1.08-.13 1.61-.14 1-.33 2.06-.51 3.07a25.22 25.22 0 0 0-.62 5.79 2.58 2.58 0 0 0 .16.61 1.15 1.15 0 0 0 .13.2v-.07a4 4 0 0 0 .49-1.17c.26-.87.47-1.75.7-2.61a25.55 25.55 0 0 1 .75-2.53 6.24 6.24 0 0 1 .54-1.18 1.91 1.91 0 0 1 .46-.53.83.83 0 0 1 .35-.18 1.26 1.26 0 0 1 .39 0 .77.77 0 0 1 .63.46 1.84 1.84 0 0 1 .13.66 7.88 7.88 0 0 1-.07 1.21c-.09.78-.24 1.52-.38 2.25-.29 1.43-.61 2.79-1 4-.75 2.48-1.5 4.58-2.11 6.29s-1.13 3-1.48 3.92c-.17.42-.31.75-.41 1a2.17 2.17 0 0 1-.19.47z",
    style: {
      fill: "#eb996e",
      transformOrigin: "148.401px 139.101px 0"
    },
    id: "elkoctpvzbokm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.65 180.89c1.9 6.71 5.62 17.06 9.61 28a1.89 1.89 0 0 0 3.49.17l9.78-20.69s-2.36-17-2.16-16.39-20.18 2.2-20.18 2.2z",
    style: {
      fill: "#395dab",
      transformOrigin: "111.09px 191.054px 0"
    },
    id: "elmb18p8mv14",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.69 177.56c0 .08-1.22.44-3.15 1.18a44.49 44.49 0 0 0-7.26 3.54 45.54 45.54 0 0 0-6.5 4.8c-1.55 1.37-2.44 2.31-2.5 2.25s.17-.28.55-.73a24.08 24.08 0 0 1 1.7-1.79 37.51 37.51 0 0 1 6.48-5 38.16 38.16 0 0 1 7.4-3.44 23.16 23.16 0 0 1 2.38-.68 2.86 2.86 0 0 1 .9-.13z",
    style: {
      fill: "#fafafa",
      transformOrigin: "111.98px 183.446px 0"
    },
    id: "elhawadffgagb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.57 182.72a10.61 10.61 0 0 1-1.64-2.14 36.56 36.56 0 0 1-3-5.74 36 36 0 0 1-1.93-6.2 10.22 10.22 0 0 1-.35-2.66 18.48 18.48 0 0 1 .71 2.57 50 50 0 0 0 2 6.09 51.12 51.12 0 0 0 2.86 5.75 21 21 0 0 1 1.35 2.33z",
    style: {
      fill: "#263238",
      transformOrigin: "122.11px 174.35px 0"
    },
    id: "eliu1s7binper",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.09 91.1a22 22 0 0 0-1.91 18.81c1 2.75 2.6 5.46 2.31 8.38s-2.57 5.81-1.77 8.69c.48 1.71 1.94 3 2.51 4.66.65 2 0 4.11-.35 6.16-.8 5.24.88 10.51 1.29 15.79s-1 11.47-5.72 13.77c-1.43.7-3.3.9-4.49-.17-1.52-1.35-1.1-3.79-.68-5.79 4.14-20-8.65-39.52-5.73-59.76.47-3.24 2.28-8.74 4.61-11s8.8-2 11 .4",
    style: {
      fill: "#263238",
      transformOrigin: "125.675px 128.511px 0"
    },
    id: "elondficlkpfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39 149.12s.61-.72 1.51-2.14a19.39 19.39 0 0 0 2.61-6.55 19.92 19.92 0 0 0 .31-4.86 51.48 51.48 0 0 1-.21-5.69 12.3 12.3 0 0 1 .57-3.06 17.06 17.06 0 0 1 1.38-2.94c1.12-1.89 2.53-3.65 3.83-5.53a15.18 15.18 0 0 0 2.72-6 18.71 18.71 0 0 0-.35-6.13 23.31 23.31 0 0 1-.44-5.68 19.11 19.11 0 0 1 1-4.88 18.55 18.55 0 0 1 3.54-6.23 13 13 0 0 1 1.36-1.39 2.68 2.68 0 0 1 .52-.43s-.67.65-1.73 2a19.2 19.2 0 0 0-4.22 11 22.77 22.77 0 0 0 .49 5.58 19 19 0 0 1 .38 6.3 15.73 15.73 0 0 1-2.8 6.17c-1.31 1.91-2.72 3.66-3.82 5.5a15.6 15.6 0 0 0-1.34 2.84 11.59 11.59 0 0 0-.57 2.94 54.22 54.22 0 0 0 .16 5.63 20 20 0 0 1-.38 4.95 18.74 18.74 0 0 1-2.8 6.59 14.53 14.53 0 0 1-1.2 1.54 3.2 3.2 0 0 1-.52.47z",
    style: {
      fill: "#455a64",
      transformOrigin: "121.565px 118.365px 0"
    },
    id: "elnku3n5a80zp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.91 150.61a3.67 3.67 0 0 1 .31-.67c.25-.47.57-1.09 1-1.87.84-1.63 2.09-4 3.32-7A30.51 30.51 0 0 0 110 130a21.5 21.5 0 0 0-.25-3.28c-.17-1.12-.43-2.25-.6-3.43a9.72 9.72 0 0 1 .08-3.68 6.58 6.58 0 0 1 2-3.21c1.88-1.71 4.15-2.83 5.33-4.84a16.37 16.37 0 0 0 1.77-6.41 25.06 25.06 0 0 1 1.38-6 21.69 21.69 0 0 1 8.09-10.22 16.74 16.74 0 0 1 1.83-1.07 3 3 0 0 1 .68-.3s-.9.48-2.39 1.54a21.85 21.85 0 0 0-5.37 5.49 21.25 21.25 0 0 0-2.44 4.71 25.45 25.45 0 0 0-1.3 6c-.3 2.13-.54 4.51-1.82 6.62s-3.62 3.31-5.41 5a6.12 6.12 0 0 0-1.89 3 9.26 9.26 0 0 0-.07 3.48c.16 1.15.41 2.29.58 3.42a20.29 20.29 0 0 1 .24 3.36 30.36 30.36 0 0 1-2.59 11.25 67.08 67.08 0 0 1-3.48 7l-1.06 1.57a3.45 3.45 0 0 1-.4.61z",
    style: {
      fill: "#455a64",
      transformOrigin: "116.61px 119.085px 0"
    },
    id: "el5iyx3mxwse7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-70",
    style: {
      transformOrigin: "440.347px 361.79px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.77 433.18a2.35 2.35 0 0 1 .18-.42c.14-.3.33-.7.56-1.21a29.54 29.54 0 0 0 1.67-4.84c1.1-4.3 1.49-10.87-.14-18.67a100.91 100.91 0 0 0-3.47-12.55c-1.46-4.45-3.17-9.17-4.56-14.28a55.38 55.38 0 0 1-2.25-16.42c.21-5.81 1.93-11.6 3.82-17.38S433.42 336 434 330.3a26.11 26.11 0 0 0-3.14-15.8c-2.5-4.61-5.65-8.56-8-12.64a44 44 0 0 1-4.81-12.16 45.33 45.33 0 0 1-.31-18.82 34.68 34.68 0 0 1 2-6.65 2.57 2.57 0 0 1-.12.44l-.4 1.27c-.34 1.12-.79 2.8-1.22 5a46 46 0 0 0 .49 18.69 43.51 43.51 0 0 0 4.83 12c2.35 4 5.51 8 8.07 12.63a26.64 26.64 0 0 1 3.23 16.13c-.59 5.78-2.55 11.47-4.44 17.24s-3.59 11.5-3.8 17.21a54.63 54.63 0 0 0 2.2 16.26c1.37 5.08 3.05 9.8 4.5 14.27a98.25 98.25 0 0 1 3.4 12.62c1.59 7.86 1.14 14.5 0 18.81a27.84 27.84 0 0 1-1.79 4.83l-.62 1.19a2.06 2.06 0 0 1-.3.36z",
    style: {
      fill: "#263238",
      transformOrigin: "427.206px 348.705px 0"
    },
    id: "elv1f1wke8wyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.06 305.89s-4.78-15.31 3.8-24.27a.53.53 0 0 1 .91.26c.46 2.53 1.03 10.23-4.71 24.01z",
    style: {
      fill: "#395dab",
      transformOrigin: "427.887px 293.67px 0"
    },
    id: "eleypkminsv9t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.93 286.72a14.65 14.65 0 0 1-.32 2.82c-.32 1.95-.69 4.23-1.09 6.75s-.77 4.81-1.08 6.75a16.84 16.84 0 0 1-.5 2.8A11.86 11.86 0 0 1 426 303c.16-1.75.47-4.15.9-6.79s.9-5 1.27-6.73a12.4 12.4 0 0 1 .76-2.76z",
    style: {
      fill: "#263238",
      transformOrigin: "427.406px 296.28px 0"
    },
    id: "elzuj5dt6iiz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.68 342s2.93-15.77 14.71-19.67a.53.53 0 0 1 .68.66c-.78 2.43-3.87 9.5-15.39 19.01z",
    style: {
      fill: "#395dab",
      transformOrigin: "439.387px 332.15px 0"
    },
    id: "elp0oe1ap26ha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.18 326.38a14.81 14.81 0 0 1-1.6 2.35l-4.13 5.45-4.1 5.47a16 16 0 0 1-1.75 2.23 11.84 11.84 0 0 1 1.4-2.48c1-1.47 2.36-3.45 4-5.58s3.13-4 4.26-5.36a12.88 12.88 0 0 1 1.92-2.08z",
    style: {
      fill: "#263238",
      transformOrigin: "437.39px 334.13px 0"
    },
    id: "elkxvpg0dixi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.5 381.53s-1.78-15.94 8.36-23.09a.52.52 0 0 1 .84.43c-.03 2.57-.94 10.23-9.2 22.66z",
    style: {
      fill: "#395dab",
      transformOrigin: "433.04px 369.93px 0"
    },
    id: "ell2rk3roh7zd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 363.26a13.32 13.32 0 0 1-.85 2.71l-2.36 6.42c-.88 2.4-1.67 4.57-2.34 6.42a16.44 16.44 0 0 1-1 2.65 11.68 11.68 0 0 1 .62-2.78c.49-1.68 1.25-4 2.18-6.5s1.84-4.75 2.53-6.36a13.93 13.93 0 0 1 1.22-2.56z",
    style: {
      fill: "#263238",
      transformOrigin: "431.725px 372.36px 0"
    },
    id: "elnbdzg5fuzs7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.37 421.31s-1.2-16 9.18-22.78a.53.53 0 0 1 .83.46c-.12 2.57-1.3 10.2-10.01 22.32z",
    style: {
      fill: "#395dab",
      transformOrigin: "442.354px 409.873px 0"
    },
    id: "el1yu4hew5m7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.49 403.29a13.85 13.85 0 0 1-.95 2.68c-.74 1.82-1.62 4-2.59 6.33s-1.82 4.5-2.56 6.33a15.56 15.56 0 0 1-1.13 2.61 12 12 0 0 1 .73-2.76c.55-1.66 1.39-3.94 2.41-6.41s2-4.69 2.75-6.27a13.36 13.36 0 0 1 1.34-2.51z",
    style: {
      fill: "#263238",
      transformOrigin: "440.875px 412.265px 0"
    },
    id: "elwz6rn3h6mgj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.18 292.44S405 285 404.69 272.61a.54.54 0 0 1 .83-.46c2.11 1.46 7.97 6.5 13.66 20.29z",
    style: {
      fill: "#395dab",
      transformOrigin: "411.935px 282.253px 0"
    },
    id: "el4nb7a9rk42e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.64 276.87a13.75 13.75 0 0 1 1.77 2.23c1.16 1.59 2.51 3.47 4 5.54l4 5.52a15.67 15.67 0 0 1 1.62 2.33 11.76 11.76 0 0 1-1.95-2.07c-1.13-1.34-2.61-3.26-4.17-5.43s-2.93-4.18-3.87-5.65a13.66 13.66 0 0 1-1.4-2.47z",
    style: {
      fill: "#263238",
      transformOrigin: "413.335px 284.68px 0"
    },
    id: "elozuzduv2ane",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.45 325.31s-14.64-6.55-15.67-18.92a.53.53 0 0 1 .8-.5c2.19 1.33 8.34 5.99 14.87 19.42z",
    style: {
      fill: "#395dab",
      transformOrigin: "426.614px 315.562px 0"
    },
    id: "el66g03v8aa4h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 310.47a13.57 13.57 0 0 1 1.9 2.11l4.34 5.29 4.35 5.27a16 16 0 0 1 1.76 2.23 12.18 12.18 0 0 1-2.08-1.95c-1.2-1.28-2.8-3.1-4.49-5.17s-3.17-4-4.21-5.41a12.85 12.85 0 0 1-1.57-2.37z",
    style: {
      fill: "#263238",
      transformOrigin: "428.175px 317.92px 0"
    },
    id: "elp6kippa1hrc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 362s-10-12.5-5.33-24a.53.53 0 0 1 .94-.08c1.39 2.17 4.72 9.13 4.39 24.08z",
    style: {
      fill: "#395dab",
      transformOrigin: "422.725px 349.835px 0"
    },
    id: "elr6folschmsr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.68 343.08a13.63 13.63 0 0 1 .74 2.75c.42 1.92.91 4.18 1.45 6.68s1.05 4.75 1.47 6.67a15.67 15.67 0 0 1 .55 2.79 12 12 0 0 1-1-2.68c-.49-1.69-1.09-4-1.65-6.66s-1-5-1.28-6.72a13 13 0 0 1-.28-2.83z",
    style: {
      fill: "#263238",
      transformOrigin: "423.785px 352.525px 0"
    },
    id: "els2s6sxn9ro8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 405.11s-14.53-6.79-15.35-19.17a.53.53 0 0 1 .81-.5c2.15 1.37 8.22 6.14 14.54 19.67z",
    style: {
      fill: "#395dab",
      transformOrigin: "428.324px 395.234px 0"
    },
    id: "el0wizgewvf20n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.77 390.06a14.89 14.89 0 0 1 1.86 2.15l4.25 5.35 4.26 5.35a15.68 15.68 0 0 1 1.72 2.26 11.78 11.78 0 0 1-2-2c-1.19-1.3-2.75-3.15-4.41-5.25s-3.1-4.05-4.12-5.48a12.23 12.23 0 0 1-1.56-2.38z",
    style: {
      fill: "#263238",
      transformOrigin: "429.815px 397.615px 0"
    },
    id: "elsa0yr68xv3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.91 342.07v1.35c0 1-.1 2.27-.17 3.89-.18 3.42-.45 8.19-.76 13.89-1 5.8-4 12.23-8 18.48-2.91 4.6-6 8.78-8.6 12.67a89.36 89.36 0 0 0-6.38 10.7 44.9 44.9 0 0 0-3 7.82c-.25.95-.45 1.7-.56 2.21a4.65 4.65 0 0 1-.21.78 3.63 3.63 0 0 1 .1-.8c.07-.52.22-1.28.45-2.25a40.87 40.87 0 0 1 2.85-7.95 85.88 85.88 0 0 1 6.37-10.77c2.62-3.92 5.65-8.11 8.55-12.68 3.95-6.22 6.89-12.55 8-18.26.4-5.69.73-10.45 1-13.87.13-1.62.24-2.91.32-3.88 0-.4.07-.74.1-1a1.32 1.32 0 0 1-.06-.33z",
    style: {
      fill: "#263238",
      transformOrigin: "451.1px 377.965px 0"
    },
    id: "el8muhxhr4icw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.26 378.53s6.15-14.8-1.58-24.51a.53.53 0 0 0-.93.18c-.69 2.48-1.96 10.09 2.51 24.33z",
    style: {
      fill: "#395dab",
      transformOrigin: "455.81px 366.172px 0"
    },
    id: "elkchjmgt6loa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.14 359.19a13 13 0 0 1 .49 2.8c.22 1.74.46 4.15.65 6.82s.28 5.09.28 6.85a11.6 11.6 0 0 1-.17 2.84 15 15 0 0 1-.25-2.83c-.13-2-.29-4.27-.46-6.82s-.33-4.86-.47-6.82a14.46 14.46 0 0 1-.07-2.84z",
    style: {
      fill: "#263238",
      transformOrigin: "455.842px 368.845px 0"
    },
    id: "elev9lsfyfv2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgvxknfpcv"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "455.81px 366.172px 0"
    },
    className: "animable",
    id: "elz64prkemyy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.26 378.53s6.15-14.8-1.58-24.51a.53.53 0 0 0-.93.18c-.69 2.48-1.96 10.09 2.51 24.33z",
    id: "el64d52alv82w",
    style: {
      transformOrigin: "455.81px 366.172px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M437.21 414.22s4.93-15.26-3.57-24.3a.53.53 0 0 0-.91.25c-.48 2.52-1.13 10.22 4.48 24.05z",
    style: {
      fill: "#395dab",
      transformOrigin: "435.529px 401.984px 0"
    },
    id: "elm209ge9i98h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.52 395a12.27 12.27 0 0 1 .72 2.76c.36 1.71.79 4.1 1.2 6.74s.69 5.05.84 6.8a12 12 0 0 1 .05 2.85 17.08 17.08 0 0 1-.48-2.8c-.29-1.95-.63-4.23-1-6.76s-.73-4.81-1-6.76a14.48 14.48 0 0 1-.33-2.83z",
    style: {
      fill: "#263238",
      transformOrigin: "435.956px 404.575px 0"
    },
    id: "el785tqdisdw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo3dfayhiuxt"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "435.529px 401.984px 0"
    },
    className: "animable",
    id: "eld228yxts4h5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.21 414.22s4.93-15.26-3.57-24.3a.53.53 0 0 0-.91.25c-.48 2.52-1.13 10.22 4.48 24.05z",
    id: "elo76rhnr8o6",
    style: {
      transformOrigin: "435.529px 401.984px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M464.1 360.44s13.13-9.2 11.81-21.54a.53.53 0 0 0-.88-.34c-1.91 1.72-7.03 7.44-10.93 21.88z",
    style: {
      fill: "#395dab",
      transformOrigin: "470.052px 349.433px 0"
    },
    id: "el7pyryjnnmps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsv575m8jff8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "470.052px 349.433px 0"
    },
    className: "animable",
    id: "el9gg6hqwy6ku"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.1 360.44s13.13-9.2 11.81-21.54a.53.53 0 0 0-.88-.34c-1.91 1.72-7.03 7.44-10.93 21.88z",
    id: "elt69ey0u5h79",
    style: {
      transformOrigin: "470.052px 349.433px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M473.53 343.51a12.33 12.33 0 0 1-1.09 2.63c-.75 1.58-1.84 3.74-3.11 6.1s-2.49 4.45-3.43 5.93a11.86 11.86 0 0 1-1.67 2.3 14.73 14.73 0 0 1 1.3-2.52c.94-1.73 2.05-3.75 3.27-6l3.26-6a14.61 14.61 0 0 1 1.47-2.44z",
    style: {
      fill: "#263238",
      transformOrigin: "468.88px 351.99px 0"
    },
    id: "el366pl0g5ha8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.51 399.09s15.84-2.47 20.08-14.13a.53.53 0 0 0-.63-.7c-2.47.74-9.63 3.59-19.45 14.83z",
    style: {
      fill: "#395dab",
      transformOrigin: "452.567px 391.666px 0"
    },
    id: "elj7dg26b20m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2auofk9t96o"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "452.567px 391.666px 0"
    },
    className: "animable",
    id: "el2b64e5q7bux"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.51 399.09s15.84-2.47 20.08-14.13a.53.53 0 0 0-.63-.7c-2.47.74-9.63 3.59-19.45 14.83z",
    id: "elctw4ttm0txk",
    style: {
      transformOrigin: "452.567px 391.666px 0"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M458.43 388.05a12.84 12.84 0 0 1-2.14 1.87c-1.37 1.1-3.3 2.56-5.47 4.12s-4.2 2.89-5.7 3.81a11.57 11.57 0 0 1-2.52 1.33 15.44 15.44 0 0 1 2.29-1.69l5.58-3.94 5.57-4a13.29 13.29 0 0 1 2.39-1.5z",
    style: {
      fill: "#263238",
      transformOrigin: "450.515px 393.615px 0"
    },
    id: "eloesde502lc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "437.17px 443.8px 0"
    },
    id: "elsefx1wppdia",
    className: "animable",
    d: "m427.39 428.25-4.62 31.1h28.8l-3.73-31.1h-20.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 437.88c0 .17-5.2.3-11.61.3s-11.62-.13-11.62-.3a114.71 114.71 0 0 1 11.62-.3 114.58 114.58 0 0 1 11.61.3z",
    style: {
      fill: "#263238",
      transformOrigin: "437.385px 437.862px 0"
    },
    id: "elg3f181x766l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.56 440.36c0 .17-5.37.3-12 .3s-12-.13-12-.3 5.37-.3 12-.3 12 .13 12 .3z",
    style: {
      fill: "#263238",
      transformOrigin: "437.56px 440.36px 0"
    },
    id: "el9evg4wqkysa",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-70",
    style: {
      transformOrigin: "298.555px 292.751px 0",
      animation: "2.9s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown,1.5s Infinite linear floating",
      animationDelay: "0s,2.9s"
    },
    className: "animable animator-active"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.57 126.54h-.79a19.23 19.23 0 0 0-2.28 0 25.62 25.62 0 0 0-8.53 2 26.19 26.19 0 0 0-10.82 8.43 23.63 23.63 0 0 0-3.78 7.73 26 26 0 0 0 2.63 19.64 22.22 22.22 0 0 0 3.4 4.52 18.48 18.48 0 0 0 4.6 3.6 11.3 11.3 0 0 0 5.77 1.45 8.29 8.29 0 0 0 5.59-2.26 8.07 8.07 0 0 0 2.23-5.76 10.62 10.62 0 0 0-2-6.13c-2.59-3.65-6.79-6.1-11.26-7.42a27.65 27.65 0 0 0-14.2-.2 29.76 29.76 0 0 0-6.84 2.72 24.65 24.65 0 0 0-5.87 4.61c-.41.47-.88.9-1.25 1.42l-1.13 1.52a28.55 28.55 0 0 0-1.84 3.34 27.1 27.1 0 0 0-2.17 7.37 27.94 27.94 0 0 0 2 15 23.17 23.17 0 0 0 9.65 11 16 16 0 0 0 6.84 2.07 12.08 12.08 0 0 0 6.75-1.62 10.55 10.55 0 0 0 4.56-5A9.06 9.06 0 0 0 319 188a13.23 13.23 0 0 0-3.76-5.32 17.22 17.22 0 0 0-5.53-3.21 21.43 21.43 0 0 0-12.18-.21 23.73 23.73 0 0 0-10 5.57 22.84 22.84 0 0 0-5.73 8.87 25.7 25.7 0 0 0 .27 18 27.29 27.29 0 0 0 8.23 11 29.61 29.61 0 0 0 7.57 4.41c.94.35 1.67.61 2.17.75l.74.24s-.26-.05-.76-.19a21.51 21.51 0 0 1-2.18-.71 28.33 28.33 0 0 1-7.66-4.34 27.41 27.41 0 0 1-8.39-11.05 26 26 0 0 1-.33-18.19 22.93 22.93 0 0 1 5.79-9 24.19 24.19 0 0 1 10.15-5.7 21.89 21.89 0 0 1 12.44.2 17.52 17.52 0 0 1 5.69 3.29 13.58 13.58 0 0 1 3.9 5.51 9.58 9.58 0 0 1-.1 6.89 11.2 11.2 0 0 1-4.77 5.21 12.62 12.62 0 0 1-7 1.7 16.26 16.26 0 0 1-7-2.14 23.64 23.64 0 0 1-9.89-11.19 28.5 28.5 0 0 1-2.06-15.28 27.86 27.86 0 0 1 2.22-7.52 28.94 28.94 0 0 1 1.88-3.41l1.16-1.55c.37-.53.85-1 1.27-1.46a25.33 25.33 0 0 1 6-4.7 30.13 30.13 0 0 1 7-2.76 28.14 28.14 0 0 1 14.47.21c4.56 1.36 8.83 3.85 11.52 7.63a11 11 0 0 1 2.1 6.4 8.54 8.54 0 0 1-2.37 6.09 8.75 8.75 0 0 1-5.9 2.37 11.63 11.63 0 0 1-6-1.51 18.59 18.59 0 0 1-4.7-3.69 23 23 0 0 1-3.45-4.61 26.37 26.37 0 0 1-2.64-20 23.9 23.9 0 0 1 3.87-7.81 26.32 26.32 0 0 1 11-8.45 25 25 0 0 1 8.59-1.88 17.47 17.47 0 0 1 2.3 0z",
    style: {
      fill: "#263238",
      transformOrigin: "308.774px 177.261px 0"
    },
    id: "elfdnct3zpcdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#395dab",
      transformOrigin: "300.855px 280.67px 0"
    },
    id: "el4xx6r4ej7ok",
    className: "animable",
    d: "M230.75 226.6h140.21v108.14H230.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#395dab",
      transformOrigin: "312.615px 238.68px 0"
    },
    id: "el30gki299au2",
    className: "animable",
    d: "m230.75 226.6 25.9 24.16h137.83l-23.52-24.16H230.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.75 226.6 140.25-.25h.11l.08.07 23.28 23.91.24.25.43.44h-.62l-137.83-.11h-.06l-25.88-24.31 26 24h-.11l137.83-.1-.18.44-.25-.25-23.27-23.91.18.08z",
    style: {
      fill: "#263238",
      transformOrigin: "312.945px 238.685px 0"
    },
    id: "elb2roszn26rc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.87 276.47a2.9 2.9 0 1 0 .21 0",
    style: {
      fill: "#263238",
      transformOrigin: "272.975px 279.369px 0"
    },
    id: "elsboiufd1usd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 276.47a2.89 2.89 0 1 0 .22 0",
    style: {
      fill: "#263238",
      transformOrigin: "306.11px 279.359px 0"
    },
    id: "elu09y7hmdo0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.19 302.35a20.72 20.72 0 0 0-2.78-6.21 18.25 18.25 0 0 0-5.3-5.08 16.17 16.17 0 0 0-17.13-.47 18.47 18.47 0 0 0-5.57 4.78 20.5 20.5 0 0 0-3.11 6.06 2.07 2.07 0 0 1 .08-.48 11.17 11.17 0 0 1 .37-1.33 16 16 0 0 1 2.37-4.47 18.19 18.19 0 0 1 5.63-5 16.45 16.45 0 0 1 17.62.48 18.14 18.14 0 0 1 5.34 5.28 16 16 0 0 1 2.13 4.6 11.74 11.74 0 0 1 .29 1.35 2.78 2.78 0 0 1 .06.49z",
    style: {
      fill: "#263238",
      transformOrigin: "289.245px 295.087px 0"
    },
    id: "elartb1jc1b8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnm9vbmbs9m"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      transformOrigin: "301.015px 243.51px 0"
    },
    className: "animable",
    id: "el2ab5oiizq9",
    d: "m231.07 227.79 24.8 31.44h115.09v-8.47H256.65l-25.58-22.97z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.31 334.5c-.14 0-.26-18.81-.26-42s.12-42 .26-42 .27 18.8.27 42-.12 42-.27 42z",
    style: {
      fill: "#263238",
      transformOrigin: "343.315px 292.5px 0"
    },
    id: "elx1vhrw40t2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "359.15px 316.965px 0"
    },
    id: "el0w3mrzk6idyo",
    className: "animable",
    d: "M352.97 309.98h12.36v13.97h-12.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#395dab",
      transformOrigin: "216.36px 238.68px 0"
    },
    id: "ellffh70bxd4b",
    className: "animable",
    d: "m230.75 226.6-28.78 24.16h28.78V226.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elclo4cxh67bq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "216.36px 238.68px 0"
    },
    className: "animable",
    id: "el12uc18l9j4z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elvc37sih85zk",
    style: {
      transformOrigin: "216.36px 238.68px 0"
    },
    className: "animable",
    d: "m230.75 226.6-28.78 24.16h28.78V226.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#395dab",
      transformOrigin: "294.495px 396.91px 0"
    },
    id: "eloqnefg6lyrd",
    className: "animable",
    d: "M213.89 334.74H375.1v124.34H213.89z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9wvydlqdrq7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      transformOrigin: "294.495px 396.91px 0"
    },
    className: "animable",
    id: "elsdczaq8u9n",
    d: "M213.89 334.74H375.1v124.34H213.89z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.71 458.2c-.14 0-.26-27.71-.26-61.89s.12-61.9.26-61.9.26 27.71.26 61.9-.12 61.89-.26 61.89z",
    style: {
      fill: "#263238",
      transformOrigin: "334.71px 396.305px 0"
    },
    id: "elcr7ceec3y4t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "355.25px 437.765px 0"
    },
    id: "elmmc4x8cbr0a",
    className: "animable",
    d: "M349.07 430.78h12.36v13.97h-12.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "272.225px 348.335px 0"
    },
    id: "elolwppsqjcdm",
    className: "animable",
    d: "M263.07 335.07h18.31v26.53h-18.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "272.225px 445.445px 0"
    },
    id: "eldx46p0ye5c",
    className: "animable",
    d: "M263.07 432.18h18.31v26.53h-18.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.7 334.74h-1.63l-4.65.05-17.13.08-56.49.13-56.51-.07-17.12-.08-4.65-.05h-1.63 1.63l4.65-.05 17.12-.08 56.51-.08 56.49.08 17.13.08 4.65.05h1.21z",
    style: {
      fill: "#263238",
      transformOrigin: "293.795px 334.795px 0"
    },
    id: "eli5xyqc2ez3",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-70",
    style: {
      transformOrigin: "66.2083px 90.3178px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m97.42 119.47-17.56-4.32h.13a29.15 29.15 0 0 1-15.15 4.55 31.87 31.87 0 0 1-9.39-1.37 29.44 29.44 0 0 1-20.22-24.44 29 29 0 0 1 7.54-23.43A30.08 30.08 0 0 1 47.86 66c.94-.59 1.88-1.2 2.86-1.71l1.49-.72.74-.36.78-.28A29.51 29.51 0 0 1 66.35 61a29.23 29.23 0 0 1 25.76 19.7 30.46 30.46 0 0 1 1.62 9.48 29.09 29.09 0 0 1-4.21 15.21v-.16c4.88 8.81 7.34 13.26 7.89 14.24-.57-1-3.12-5.37-8.17-14.09v-.16a28.86 28.86 0 0 0 4-15 29.78 29.78 0 0 0-1.64-9.32 28.76 28.76 0 0 0-25.29-19.3 29 29 0 0 0-12.37 1.9l-.76.27-.73.36-1.46.7c-1 .51-1.88 1.1-2.81 1.68a29.71 29.71 0 0 0-5 4.34 28.49 28.49 0 0 0-7.41 23 28.93 28.93 0 0 0 10.83 19.23 28.47 28.47 0 0 0 9 4.8 31.16 31.16 0 0 0 9.23 1.39 28.88 28.88 0 0 0 15-4.39H80z",
    style: {
      fill: "#263238",
      transformOrigin: "66.2083px 90.3178px 0"
    },
    id: "el46l198tbfp1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 77.3.89 14.7a2.38 2.38 0 0 0 2.23 2.23 2.39 2.39 0 0 0 2.51-2.12l1.63-14.73a1.87 1.87 0 0 0-1.89-2.07H63.8A1.86 1.86 0 0 0 62 77.3z",
    style: {
      fill: "#395dab",
      transformOrigin: "65.6331px 84.7718px 0"
    },
    id: "elu49pirjr2s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 102.44a3.58 3.58 0 1 1-2.27-4.53 3.58 3.58 0 0 1 2.27 4.53z",
    style: {
      fill: "#395dab",
      transformOrigin: "65.6031px 101.308px 0"
    },
    id: "el0iuvzao62dw",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.e3517d44c2bf58f989c3ca276a07a986.svg";
export { ForwardRef as ReactComponent };